import React, { ReactNode } from 'react'

import * as Form from '@radix-ui/react-form';
import { Either } from '../../utils/propsUtil';
import * as S from './styles';
import { View } from '../Basic/View/view';

/* eslint-disable no-unused-vars */
interface Props0 {
  children: ReactNode
  handleForm: (event: React.FormEvent<HTMLFormElement>) => void
  idForm?: string
  formRef?: React.RefObject<HTMLFormElement>
}

interface Props1 {
  buttonText: string
}

interface Props2 {
  button?: ReactNode
  actionButton?: ReactNode
  hideSubmit?: boolean
}

export type FormProps = Props0 & Either<Props1, Props2>;

export function Forms({ children, ...props }: FormProps) {
    
  return (
    <View>
      <Form.Root ref={props.formRef} onSubmit={props.handleForm} id={props.idForm} className="FormRoot" >
        <Form.Field className="FormField" name="email" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {children}
        </Form.Field>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {props.actionButton &&
            <>
              {React.cloneElement(props.actionButton as React.ReactElement, { type: 'button' } as React.ButtonHTMLAttributes<HTMLButtonElement>)}
            </>
          }
          {!props.hideSubmit && props.buttonText && (
            <Form.Submit type='submit' asChild>
              <S.FormButton type='submit' size='md'>
                {props.buttonText}
              </S.FormButton>
            </Form.Submit>
          )}
          {!props.hideSubmit && props.button && (
            <Form.Submit asChild>
              {props.button}
            </Form.Submit>
          )}

        </div>
      </Form.Root>
    </View>
  )
}

export const FormSubmit = Form.Submit;
FormSubmit.displayName = 'FormSubmit';